/**
 * Full Image Gallery component.
 * @module components/media
 */
import { _extends } from 'brei-project-utils';

const media = {

	elem: {
		$body: $('body'),
		$slider: $('.media__items')
	},

	options: {
		adaptiveHeight: false,
		dots: false,
		draggable: true,
		fade: true,
		infinite: true,
		responsive: [],
		rows: 0,
		slidesToScroll: 1,
		slidesToShow: 1,
		speed: 500,
		appendArrows: false,
		x_of_x: $('.media-amount'),
		customPaging: function (slider) {
			let lSlide = slider.slickCurrentSlide() + 1;
    		let lCount = slider.slideCount;
			/* This add slide x of x to desktop & mobile */
			this.x_of_x.text(`${lSlide} /  ${lCount}`);
		},
		clickNav: function(e){
			/* mobile slide click */
			e.preventDefault();
			let lNext = e.target.parentNode.dataset.id === 'next';

			//alert(lNext)
			
			if (lNext) {
				media.elem.$slider.slick('slickNext')
			} else {
				media.elem.$slider.slick('slickPrev')
			}
		}
	},



	init() {

		if (this.elem.$slider.length > 0) {
			this.activateSliders();
		}

	},

	activateSliders() {

		const _this = this;

		this.elem.$slider.each(function () {
			if($(this).children().length) {

				let prev = $(this).parents('.js-has-carousel').find('.js-prev');
				let next = $(this).parents('.js-has-carousel').find('.js-next');

				let options = _extends({}, _this.options);
				
				if (prev.length > 0) {
					options.prevArrow = prev;
				}

				if (next.length > 0) {
					options.nextArrow = next;
				}

				$(this).on('afterChange', function(event,slick,currentSlide) {
					let caption = $(this).find('.media__imagery').eq($(this).slick('slickCurrentSlide')).find('figcaption').html();
					if(caption === undefined) {
						caption = '';
					}
					/* Assign the x of x slide count */
					options.customPaging(slick, currentSlide);
					$(this).closest('.media').find('.media__caption').html(caption);
				}).on('init', function(event,slick,currentSlide) {
					let caption = $(this).find('.media__imagery').eq(0).find('figcaption').html();
					if(caption === undefined) {
						caption = '';
					}
					
					$(this).closest('.media').find('.media__caption').html(caption);


					/* Assign the x of x slide count */
					options.customPaging(slick, currentSlide);
					/*  Move the controls for proper placement */
					// let lControls = $('#media_controls');
					// $(lControls).appendTo('#media_items');

					let lMedia = $(this).closest('.media');
					let lControls = lMedia.find('[data-id="media_controls"]');
					let lItems = lMedia.find('.media__items');
					$(lControls).appendTo(lItems);
					
					/* Assign functions for small screens */
					//$('#media_controls_sm a').on('click', options.clickNav );
					lMedia.find('.media__controls a').on('click', options.clickNav );
					

				}).slick(options);
				
			}
		});
	}

};

export { media };

// to use:
//
// import media from './modules/media';
//
// media.init();
